// authContext.tsx
import React, { createContext, useState, useEffect } from "react";
import {
  AuthContextProps,
  UserInfo,
  prefundInfo,
} from "../lib/interfaces/index";


export const AuthContext = createContext<AuthContextProps>({
  username: "",
  loggedIn: false,
  userInfo: null,
  prefundInfo: null,
  approverStatus: false,
  internalPartnerName: "",
  setCredentials: () => {},
  setPrefundCredentials: () => {},
  setLoggedIn: () => {},
  handleLogout: () => {},
  setUserData: () => {},
  setPartnerName: () => {},
  setApproverStatus: () => {},
});

export const AuthProvider: React.FC<React.PropsWithChildren<{}>> = ({
  children,
}) => {
  const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userContactNo, setUserContactNo] = useState<number>();
  const [userFName, setUserFName] = useState("");
  const [userMName, setUserMName] = useState("");
  const [userlName, setUserLName] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);
  const [balance, setPrefundBalance] = useState<number>();
  const [credit, setCredit] = useState<number>();
  const [currency, setCurrency] = useState("");
  const [prefundStatus, setPreFundStatus] = useState("");
  const [userData, setUserDataState] = useState<UserInfo | null>(null);
  const [prefundData, setPreFundData] = useState<prefundInfo | null>(null);
  const [internalPartnerName, setInternalPartnerName] = useState("");
  const [approverStatus, setApproverStatus] = useState(false);

  // Load stored data from localStorage
  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    // const storedPassword = localStorage.getItem("password");
    const storedLoggedIn = sessionStorage.getItem("loggedIn") === "true"; // Parse as boolean
    const storedUserInfo = sessionStorage.getItem("userInfo");
    const storedPreFund = sessionStorage.getItem("prefundInfo");
    const storedApproverStatus = sessionStorage.getItem("approverStatus");

    if (storedUsername && storedLoggedIn) {
      setUsername(storedUsername);
      // setPassword(storedPassword);
      setLoggedIn(true);
      setUserDataState(storedUserInfo ? JSON.parse(storedUserInfo) : null);
      setPreFundData(storedPreFund ? JSON.parse(storedPreFund) : null);
      setApproverStatus(
        storedApproverStatus ? JSON.parse(storedApproverStatus) : null
      );
    }
  }, []);

  // Save data to localStorage
  useEffect(() => {
    if (loggedIn) {
      sessionStorage.setItem("username", username);
      // localStorage.setItem("password", password);
      sessionStorage.setItem("loggedIn", "true");
      sessionStorage.setItem("userInfo", JSON.stringify(userData));
      sessionStorage.setItem("prefundInfo", JSON.stringify(prefundData));
      sessionStorage.setItem("approverStatus", JSON.stringify(approverStatus));
    }
  }, [loggedIn, userData, prefundData, approverStatus, username]);

  const setCredentials = (userInfo: UserInfo) => {
    setUserEmail(userInfo.userEmail);
    setUserContactNo(userInfo.userContactNo);
    setUserFName(userInfo.userFName);
    setUserMName(userInfo.userMName);
    setUserLName(userInfo.userLName);
    setUserDataState(userInfo); // Update the user data state
  };

  const setPrefundCredentials = (prefundInfo: prefundInfo) => {
    setPrefundBalance(prefundInfo.balance);
    setCredit(prefundInfo.credit);
    setCurrency(prefundInfo.currency);
    setPreFundStatus(prefundInfo.prefundStatus);
    setPreFundData(prefundInfo); // Update prefund data
  };

  const handleSetLoggedIn = (loggedIn: boolean, username: string) => {
    if (loggedIn) {
      setUsername(username);
      // setPassword(password);
      setLoggedIn(true);
    } else {
      setUsername("");
      // setPassword("");
      setLoggedIn(false);
      setUserDataState(null); // Clear user data on logout
    }
  };

  const handleLogout = () => {
    handleSetLoggedIn(false, "");
  };

  const setUserData = (userInfo: UserInfo) => {
    setUserDataState(userInfo); // Update the context state
  };
  const setPartnerName = (partnersName: string) => {
    setInternalPartnerName(partnersName);
  };
  return (
    <AuthContext.Provider
      value={{
        username,
        // password,
        loggedIn,
        userInfo: userData,
        prefundInfo: prefundData,
        approverStatus: approverStatus,
        internalPartnerName,
        setCredentials,
        setPrefundCredentials,
        setLoggedIn: handleSetLoggedIn,
        handleLogout,
        setUserData, // Provide the setUserData function
        setPartnerName,
        setApproverStatus,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
